import src from "IMAGE";
export default { src, width: 48, height: 48, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAARklEQVR42q2NsQ0AIAgEiRQ0xgmcQBpZnDGYS6EiNhb6yTX/lzzAjxRErJt2UH0DIupjsM4plvHOtxCYWUXEMt6FcL14zgLinBFRQbr1RgAAAABJRU5ErkJggg=="};
